import {Form,Card,Button,message} from 'antd'
import { useCallback, useEffect, useState } from 'react';
import ReactQuill from "react-quill";
import { useParams,useLocation,useHistory } from 'react-router-dom'
import CenterService from '../../../../services/CenterService';
export default function InformationForm(props) {
    const location=useLocation();
    const history= useHistory();
    const params= useParams();
    const [form] = Form.useForm();
    
    const [list,setList]=useState()
    const centerID=params?.id;
    const actionForm= params?.option
      
      const updateInformationCenter=useCallback((dataInformation)=>{
        CenterService.updateCenterDataByCenter(centerID,dataInformation).then((res)=>{
            message.success("Actualización de la información exitosa");
            history.goBack();
        })
      })
      const createInformationCenter=useCallback((dataInformation)=>{
        CenterService.createCenterDataByCenter(centerID,dataInformation).then((res)=>{
            message.success("Registro de la información exitosa");
            history.goBack();
        })
      })
    
      const onFinish=()=>{
        console.log(actionForm)
        var dataInformation=form.getFieldsValue()
        console.log(dataInformation)
        form.resetFields()
        if(actionForm==="create"){
            createInformationCenter(dataInformation)
        }
        if (actionForm==="update") {
            updateInformationCenter(dataInformation)
        }
      }
    useEffect(()=>{
        setList(location.state?.list);
    },[list])

    

    const listFormItems=(listOp)=>{
        let listItems=[]
        listOp?.forEach(item => {
            form.setFieldValue(item.key,item.data)
            listItems.push(
                <Form.Item
                name={item.key}
                label={item.label}
                >
                    <div>
                        <ReactQuill
                        key={"RQ"+item.key}
                        value={actionForm==="update"?item.data:""}
                        onChange={(e)=>form.setFieldValue(item.key,e)}
                        />
                    </div>
                </Form.Item>
            )
        });
        return listItems;
    }
    return(
        <>
        <Card
        style={{margin:30}}
        >
            <Form
            form={form}
            preserve={true}
            onFinish={onFinish}
            >
                {listFormItems(list)}
            </Form>
            <Card>
                <Button 
                key={"createBtn"}
                style={{
                    margin: '0 8px',
                    }}
                type='Submit' 
                onClick={()=>form.submit()}
                >
                    {actionForm==="create"?"Crear":"Actualizar"}
                </Button>
                <Button
                key={"updateBtn"}
                style={{
                margin: '0 8px',
                }}
                onClick={() => {history.goBack()}}
                >
                    Cancelar
                </Button>
            </Card>
        </Card>
       </>
    )
}